import { ReactElement } from 'react';
import { FormListFieldData, FormListOperation } from 'antd/es/form';
import ContentBodyLayout from './ContentBodyLayout';
import TableHeader from './TableHeader';
import TableRows from './TableRows';
import { BulkCreateAdvisorsResponse } from '@minutes-system/backend/src/api/advisors/schema';

interface Props {
  fields: FormListFieldData[];
  onRemove: FormListOperation['remove'];
  minRows: number;
  results: BulkCreateAdvisorsResponse | null;
}

const ContentBody = ({ fields, onRemove, minRows, results }: Props): ReactElement => (
  <section>
    <ContentBodyLayout
      header={<TableHeader />}
      body={<TableRows fields={fields} onRemove={onRemove} minRows={minRows} results={results} />}
    />
  </section>
);

export default ContentBody;
